<template>
  <div>
    <help-list-examine :titleText="title"></help-list-examine>
  </div>
</template>

<script>
/* global PUBLIC_EMPTY_TITLE */

import HelpListExamine from '@/components/HelpListExamine.vue';

export default {
  name: 'Help',
  components: {
    HelpListExamine,
  },
  data() {
    return {
      title: PUBLIC_EMPTY_TITLE === '1' ? '意见反馈' : '帮助和反馈',
    };
  },
};
</script>
